import { handlePromise } from "../apiControllers/helpers";
import Env from "../../Environments";
import { apiUrls } from "../../constants/apiUrls";

export const GetBasicDetailsAPI = async (params) => {
  const apiPayload = {
    method: "GET",
    url: Env.getLcoBasePath() + apiUrls.basicUserDetails,
    params: params
  };

  return handlePromise(apiPayload);
};

export const licenseMandateAPI = async () => {
  const apiPayload = {
    method: "GET",
    url: Env.getLcoBasePath() + apiUrls.getLicenseMandate,
    useParentKey: true
  };

  return handlePromise(apiPayload);
};
